import React, { FC } from 'react';
import { MenuItem } from 'moduleBase/components/menu/MenuItem';
import { BottomData } from 'moduleBaseMenu/types/BottomData';
import { LeftBanners } from './LeftBanners';

type PropsType = {
  bottomData: BottomData;
};

const Bottom: FC<PropsType> = ({ bottomData }) => {
  if (!bottomData) {
    return null;
  }

  const menuItems = bottomData.items.map((menuItem) => (
    <li className="d-flex align-items-center" key={menuItem.label}>
      <MenuItem {...menuItem} className="text-truncate" />
    </li>
  ));

  return (
    <ul className="desktop-nav-list mt-auto">
      {menuItems}
      <div className="mt-3" />
      <LeftBanners banners={bottomData.banners} />
    </ul>
  );
};

export { Bottom };
